import { render, staticRenderFns } from "./SupportEdit.vue?vue&type=template&id=e2f203b8"
import script from "./SupportEdit.vue?vue&type=script&lang=js"
export * from "./SupportEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports